import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Eliminar datos de autenticación
    localStorage.removeItem("auth");
    localStorage.removeItem("role");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("username");
    sessionStorage.clear();
    document.cookie = "session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    // Mostrar mensaje de cierre de sesión
    toast.info("Sesión cerrada correctamente.");

    // Redirigir al login después de un pequeño retraso
    setTimeout(() => navigate("/login"), 1500);
  }, [navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>Cerrando sesión...</h2>
    </div>
  );
};

export default Logout;
